import React, { Component } from 'react'
import { connect } from 'react-redux'
import TVLift from '../../layout2.0/components/roomControl2/InnComRoomControl/TVLift';
import RoomTheme from '../../layout2.0/components/roomControl2/InnComRoomControl/RoomTheme';
import AcControl from '../../layout2.0/components/roomControl2/InnComRoomControl/acControl';
import {getRoomControlZonesWiseData} from '../../action/roomControlAction';

class multiControllerWidget extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {

        return (
            <div class="room-control-main">

                {this.props.rooms.map((room, index) => (
                    <div class={`room-control-group ${room.code}`}>
                        <div class="room-control-header">{room.label}</div>

                        {room.hvac && room.hvac.map((hvacData, idx) => ( <AcControl OnHomeScreen={true} hvacData={hvacData} />) )}

                        {room.lights && room.lights.map((iterator, idx) =>(<RoomTheme OnHomeScreen={true} stopCompDidMound={true} lightData={iterator} />)) }

                        {room.curtain && room.curtain.map((iterator, idx) =>(<RoomTheme OnHomeScreen={true} stopCompDidMound={true} curtainData={iterator} />)) }

                        {room.tvLift  && room.tvLift.map((TVdata, idx) => ( <TVLift OnHomeScreen={true} stopCompDidMound={true} TVdata={room.tvLift.length > 0 ? TVdata : null} />)) }

                    </div>
                ))}

            </div>
        )
    }
}

multiControllerWidget.defaultProps = {
}

const mapStateToProps = state => {
    return {
        rooms: state.store.RoomControlZonesWiseData.rooms
    }
}
export default connect(
    mapStateToProps, {
        getRoomControlZonesWiseData

}
)(multiControllerWidget);